module.exports = __webpack_public_path__ + "img/game_0_.c4092333.png";